import { get } from "lodash";
import { connect } from "react-redux";
import {
  getAccountInfo,
  getIsIslamicBanking,
  getOrganizationInfo,
  getKycAnnexureDetails,
  getSignatories,
  getDatalist,
  checkRequiredKycAnnexureDocs
} from "../../../../store/selectors/appConfig";
import { getIsEditableStatusSearchInfo } from "../../../../store/selectors/searchProspect";
import { KycAnnexureComponent } from "./KycAnnexure";
import { initialVisitDetails } from "../../constants";

const filterSignatories = (signatories = []) =>
  signatories
    .map((s, i) => ({ ...s, index: i }))
    .filter(el => el.kycDetails.isShareholderACompany === false);

const findDsaChecklistDoc = (kycAnnexureDocuments = []) =>
  kycAnnexureDocuments.find(doc => doc.documentType === "BAIS Account Opening Checklist") || {};

const findSiteVisitReport = (kycAnnexureDocuments = []) =>
  (kycAnnexureDocuments || []).find(doc => doc.documentType === "Site Visit Report") || null;

//ro-assist-brd3-17
const mapStateToProps = (state, { index }) => ({
  islamicBanking: getIsIslamicBanking(state),
  isExpress: get(getAccountInfo(state)[0], "express", ""),
  organizationInfo: getOrganizationInfo(state),
  kycAnnexureDetails: getKycAnnexureDetails(state),
  kycAnnexureBankDetails: get(getKycAnnexureDetails(state), "bankDetails"),
  kycVisitDetails: get(getKycAnnexureDetails(state), "visitDetails", initialVisitDetails),
  datalist: getDatalist(state),
  isComeFromROScreens: getIsEditableStatusSearchInfo(state),
  signatories: filterSignatories(getSignatories(state)),
  dsaChecklistDoc: findDsaChecklistDoc(checkRequiredKycAnnexureDocs(state)),
  siteVisitReport: findSiteVisitReport(checkRequiredKycAnnexureDocs(state))
});

export const KycAnnexure = connect(mapStateToProps)(KycAnnexureComponent);
